import axios from 'axios';
import flatstore from 'flatstore';
import {siteInfo, defaultLang} from './config';
//import {translation} from './../i18n/dutch';
import {keys, findKey, includes, isEmpty, trim} from 'lodash';
//import {translation} from './../i18n/english';
import {getStorage, setStorage, removeStorage, clearStorage} from './storage';
import { useTranslation } from 'react-i18next';

flatstore.set('loading', false);


if (!String.prototype.replaceAll) {
    String.prototype.replaceAll = function(str, newStr){
        // If a regex pattern
        if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
            return this.replace(str, newStr);
        }
        // If a string
        return this.replace(new RegExp(str, 'g'), newStr);
    };
}


export function get(url, datastate, options={}){
    //console.log(10);
    flatstore.set('loading', true);
    try{
        axios.get(url, options).then(function(response){
            //console.log(response);
            flatstore.set(datastate, response.data); 
            flatstore.set('loading', false);
            //setStorage(url, response.data);
            
        }).catch(err => {
            if(err.response){
                flatstore.set('err_data', err.response.status);
                flatstore.set('loading', false);
            }

        });
    }catch(err){
        //console.log(11);
        if(err.response){
            flatstore.set('err_data', err.response.status);
            flatstore.set('loading', false);
        }
    }
    /*
    //var data = getStorage(url);
    var data = false; 
    
    if(data){
        flatstore.set(datastate, data); 
        flatstore.set('loading', false);
    }else{
        try{
            axios.get(url, options).then(function(response){
                //console.log(response);
                flatstore.set(datastate, response.data); 
                flatstore.set('loading', false);
                setStorage(url, response.data);
                
            });
        }catch(err){
            console.log(err);
        }
    }
    */
}

export function getR(url, datastate, options={}){
    try{
        axios.get(url, options).then(function(response){
            flatstore.set(datastate, response.data); 
            //setStorage(url, response.data);
            //console.log(response);
        }).catch(err => {
            //console.log(url);
            if(err.response){
                flatstore.set('err_data', err.response.status);
                flatstore.set('loading', false);
            }

        });
        //console.log(url);
    }catch(err){
        //console.log(11);
        if(err.response){
            flatstore.set('err_data', err.response.status);
            flatstore.set('loading', false);
        }
    }
    /*
    //console.log(url, datastate);
    
    //var data = getStorage(url);
    var data = false;
    //console.log(data);
    if(data){
        flatstore.set(datastate, data); 
    }else{
        try{
            axios.get(url, options).then(function(response){
                flatstore.set(datastate, response.data); 
                setStorage(url, response.data);
                //console.log(response);
            });
            
        }catch(err){
            console.log(err);
        }
    }
    */
}

export async function getSync(url, datastate, options={}){
    flatstore.set('loading', true);

    try{
        await axios.get(url, options).then(function(response){
            flatstore.set(datastate, response.data); 
            flatstore.set('loading', false);
        });
    }catch(err){
        if(err.response){
            flatstore.set('err_data', err.response.status);
            flatstore.set('loading', false);
        }
        //console.log(err.response.status);
    }
    /*
    //flatstore.set('loading', true);
    //var data = getStorage(url);
    var data = false;
    if(data){
        flatstore.set(datastate, data); 
        //flatstore.set('loading', false);
    }else{
        try{
            await axios.get(url, options).then(function(response){
                flatstore.set(datastate, response.data); 
                flatstore.set('loading', false);
                setStorage(url, response.data);
            });
        }catch(err){
            flatstore.set('err_data', err.response.status);
            flatstore.set('loading', false);
            //console.log(err.response.status);
        }
    }
    */
}

export async function getReturn(url, options={}){
    try{
        return await axios.get(url, options);
    }catch(err){
        console.log(err);
    }
}

export function post(url, postdata, datastate, options={}){
    flatstore.set('loading', true);
    try{
        axios.post(url, postdata, options).then(function(response){flatstore.set(datastate, response.data);flatstore.set('loading', false);});
    }catch(err){
        console.log(err);
    }
}

export async function postSync(url, postdata, datastate, options={}){
    flatstore.set('loading', true);
    try{
        await axios.post(url, postdata, options).then(function(response){flatstore.set(datastate, response.data); flatstore.set('loading', false);});
    }catch(err){
        console.log(err);
    }
}

export function postR(url, postdata, datastate, options={}){
    try{
        axios.post(url, postdata, options).then(function(response){flatstore.set(datastate, response.data);});
    }catch(err){
        console.log(err);
    }
}

export function isMobile() {
    if(window.innerWidth <= 780){
        return true;
    }else{
        return false;
    }
}

export function currentLang() {
    var lang = window.location.pathname.substring(1,3);
    //console.log(lang);
    if(includes(keys(siteInfo), lang)){
        return lang;
    }else{
        return defaultLang;
    }
}

export function apiURL(){
    //console.log(siteInfo[currentLang()]['lang']);
    var href = window.location.href;
    //var pathname = window.location.pathname;
    var base_url = process.env.REACT_APP_URL;
    var base_params = "/"+currentLang()+"/"+siteInfo[currentLang()]['lang'];

    var is_dev = localStorage.getItem('bypass_api_cache') == 'true' ? true : false;

    if(is_dev){
        base_url = process.env.REACT_APP_DEV_URL;
    }
    
    if(href.includes('local')){
        base_url = process.env.REACT_APP_STAGING_URL;
    }else if(href.includes('alpha')){
        base_url = process.env.REACT_APP_STAGING_URL;
    }else if(href.includes('staging')){
        base_url = process.env.REACT_APP_STAGING_URL;
    }

    return base_url+base_params;
}

export function isProduct(product_url){  // (menu_product, category_slug)
    var arr = [];
    window.urlMaps[currentLang()].map(item=>{
        if(item.name == 'products')
            arr.push(item.pattern.replace(':slug?', '').replace(currentLang(), '').replaceAll('/', ''));
        if(item['items']){
          item['items'].map(row=>{
            var tempURL = row.pattern.replace('/'+currentLang(), '');
            if(!isEmpty(row.pattern) && !isEmpty(tempURL)){
              if(row.component == 'products'){
                 //console.log(row.pattern);
                arr.push(row.pattern.replace(':slug?', '').replace(currentLang(), '').replaceAll('/', ''));
              }
            }
          })
        }
      })
    window.product_urls = arr;
    
    if(product_url && !isEmpty(trim(product_url))){
        if(arr.includes(product_url)){
            return true;
        }
    }else{
        var url = window.location.pathname.split('/').filter(str=>str.length>1);
        if(url && url[1]){
            //console.log(url, url[1], product_url);
            //console.log(url[1], arr);
            /*
            if(window.location.href.includes(category_slug) || window.location.href.includes(menu_product)){
                return true;
            }
            */
            if(arr.includes(url[1])){
                return true;
            }
        }
    }
    return false;
}

export function productURL(url, slug, type){
    //var { t } = useTranslation();
    //return '/'+currentLang()+'/'+url+'/'+slug;
    
    var arr = [];
    var defaultURL = '';
    window.urlMaps[currentLang()].map(item=>{
        if(item.name == 'products')
            defaultURL = item.pattern.replace(':slug?', '');
        if(item['items']){
          item['items'].map(row=>{
            var tempURL = row.pattern.replace('/'+currentLang(), '');
            if(!isEmpty(row.pattern) && !isEmpty(tempURL)){
              if(row.component == 'products'){
                arr[row.name] = row;
              }
            }
          })
        }
      })
    if(includes(keys(arr), type)){
        return arr[type].pattern.replace(':slug?', '')+slug;
    }else{
        return defaultURL+slug;      
    }
    
    //return '/'+currentLang()+'/'+url+'/'+slug;
}

export function farmerURL(url){
    //console.log(window.urls['farmers']);
    var base = window.urls['farmers'].replace(':slug?/:page?', '');
    return base+url;
}

export function recipeURL(url){
    var base = window.urls['recipes'].replace(':slug?/:page?', '');
    return base+url;
}

export function meatcutURL(url){
    var base = window.urls['meatcuts'].replace(':slug?', '');
    return base+url;
}
export function breedURL(url){
    var base = window.urls['breeds'].replace(':slug?/:page?', '');
    return base+url;
}

export function getPath(num){
    var url = window.location.pathname.split('/').filter(str=>str.length>1);
    return url[num];
}

export function getPaymentLogos(){
    return siteInfo[currentLang()]['payments'];
}
export function animalPercent(value){
    var price = value;
    if(value >= 100)
        price = 100;
    if(value <= 3)
        price = 3;
    if(value < 100 && value > 97)
        price = 97;
    return price;
}

export function accentsTidy(s){
    var r=s.toLowerCase();
    r = r.replace(new RegExp(/\s/g),"");
    r = r.replace(new RegExp(/[àáâãäå]/g),"a");
    r = r.replace(new RegExp(/æ/g),"ae");
    r = r.replace(new RegExp(/ç/g),"c");
    r = r.replace(new RegExp(/[èéêë]/g),"e");
    r = r.replace(new RegExp(/[ìíîï]/g),"i");
    r = r.replace(new RegExp(/ñ/g),"n");                
    r = r.replace(new RegExp(/[òóôõö]/g),"o");
    r = r.replace(new RegExp(/œ/g),"oe");
    r = r.replace(new RegExp(/[ùúûü]/g),"u");
    r = r.replace(new RegExp(/[ýÿ]/g),"y");
    r = r.replace(new RegExp(/\W/g),"");
    return r;
}
 
export function hasClass(el, className) {
    if (el.classList) return el.classList.contains(className);
    return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
}

export function addClass(el, className) {
   if (el.classList) el.classList.add(className);
   else if (!hasClass(el, className)) el.className += " " + className;
}

export function removeClass(el, className) {
    if (el.classList) el.classList.remove(className);
    else if (hasClass(el, className)) {
      var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
      el.className=el.className.replace(reg, ' ');
    }
}

